var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Multiselect', {
    attrs: {
      "options": _vm.options,
      "label": _vm.label,
      "multiple": "",
      "track-by": "value",
      "placeholder": "輸入查詢",
      "selectLabel": "請選擇",
      "selectedLabel": "（已勾選）",
      "deselectLabel": "取消勾選"
    },
    on: {
      "input": _vm.handleSelect
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('div', [_vm._v("查無資料")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }